import { render } from "./ClosedTripSheetTable.vue?vue&type=template&id=23528501&scoped=true"
import script from "./ClosedTripSheetTable.vue?vue&type=script&lang=js"
export * from "./ClosedTripSheetTable.vue?vue&type=script&lang=js"

import "./ClosedTripSheetTable.vue?vue&type=style&index=0&id=23528501&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23528501"]])

export default __exports__